import { render, staticRenderFns } from "./ProjectReference.vue?vue&type=template&id=a115f9a0&scoped=true"
import script from "./ProjectReference.vue?vue&type=script&lang=js"
export * from "./ProjectReference.vue?vue&type=script&lang=js"
import style0 from "./ProjectReference.vue?vue&type=style&index=0&id=a115f9a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a115f9a0",
  null
  
)

export default component.exports